import React from 'react';
import { BsCalendar } from 'react-icons/bs';
import GlassCard from './GlassCard';
import ScrollEffectWrapper from './ScrollEffectWrapper';
import NMULogo from '../images/NMULogo.png';

function EducationSection() {
  return (
    <section className="section education-section">
      <div className="container">
        <ScrollEffectWrapper>
          <div className="section-header">
            <h2 className="section-title">Education</h2>
            <p className="section-subtitle">Academic background and qualifications</p>
          </div>
        </ScrollEffectWrapper>

        <ScrollEffectWrapper delay={200}>
          <GlassCard className="education-card">
            <div className="education-header">
              <img src={NMULogo} alt="NMU Logo" className="education-logo" />
              <div className="education-info">
                <h3 className="education-school">Northern Michigan University</h3>
                <p className="education-degree">Bachelor of Science in Mobile & Web Application Development<br />Minor in Information Assurance/Cyber Defense</p>
                <p className="education-date">
                  <BsCalendar /> Started Summer 2026 - Expected Graduation Winter 2029
                </p>
              </div>
            </div>
            <div className="education-content">
              <h5>Transferred to NMU from SNHU</h5>
              <p>
                I am currently pursuing studies at Northern Michigan University in the Mobile & Web Application Development program with a minor in
                Information Assurance/Cyber Defense. I am looking to graduate in Winter 2029 with my Bachelor of Science in Mobile & Web App Development.
                Once I have my degree, I plan to start my Masters or go straight into industry. With the masters I want the thesis research route.
                I am passionate about learning and developing my skills in this field and am excited to see where my education takes me!
              </p>
            </div>
          </GlassCard>
        </ScrollEffectWrapper>
      </div>
    </section>
  );
}

export default EducationSection;
